import React, { useState, useEffect, useContext } from "react";
import { css } from "emotion";
import { Button, Header, Grid, Form } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import { getRequest, postRequest } from "../../helpers/ApiHelpers";
import { UserContext } from "../User";
import RichTextEditor from "../RichTextEditor";
import { logEvent } from "../../helpers/analyticsLogger";

export function EditAddStateNote({ match, history }) {
  const { user } = useContext(UserContext);
  const [state, setState] = useState({
    submitting: false,
    adminState: {
      id: Number(match.params.id),
      name: "",
      note: ""
    }
  });

  async function getState(id) {
    const result = await getRequest("/adminState/getState", { id });
    if (result.success) {
      setState(state => ({
        ...state,
        adminState: result.data
      }));
    }
  }

  useEffect(() => {
    getState(match.params.id);
  }, []);

  async function saveChanges() {
    if (state.submitting) {
      return;
    }

    setState(state => ({ ...state, submitting: true }));
    const result = await postRequest("/adminState/saveStateNote", {
      id: state.adminState.adminStateNoteId || 0,
      stateId: state.adminState.id,
      note: state.adminState.note
    });

    if (result.success) {
      logEvent(null, "Edited", "Admin State Note");
      history.goBack();
      return;
    }

    setState(state => ({ ...state, submitting: false }));
  }

  if (!user.isOwner && !user.isOwnerPlus) {
    return null;
  }

  return (
    <div className={css({ width: 805, paddingBottom: 34 })}>
      <Header style={{ fontSize: 24, marginBottom: 41 }} as="h3">
        {`Edit ${state.adminState.name} Note`}
      </Header>
      <Form>
        <Grid>
          <Grid.Row columns={1}>
            <Grid.Column>
              <Form.Field>
                <label>Note</label>
                <RichTextEditor
                  value={state.adminState.note}
                  onChange={value =>
                    setState(state => ({
                      ...state,
                      adminState: { ...state.adminState, note: value }
                    }))
                  }
                  minHeight={260}
                />
              </Form.Field>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={1}>
            <Grid.Column
              floated="right"
              className={css({ textAlign: "right" })}
            >
              <Button
                size="large"
                className="cancelButton"
                onClick={() => history.goBack()}
              >
                Cancel
              </Button>
              <Button
                size="large"
                className="saveButton"
                onClick={() => saveChanges()}
              >
                {state.submitting ? "Submitting..." : "Save"}
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    </div>
  );
}

export default withRouter(EditAddStateNote);
